import * as React from 'react'
import {Box} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";
import {formatPriceSymbol} from "@ui-seeker/utils";


export default function priceColumn(key, label) {
	return {
		name: key, label: label,
		options: {
			setCellHeaderProps: () => ({ sx: {
				whiteSpace: 'nowrap',
			}}),
			customBodyRowRenderLite: (value, { currency, ...dataRow }) => <Box sx={{ textAlign: 'center', position: 'relative' }}>
				{ !!value && <Box>
					{ !!dataRow[`${key}BuyBox`] && <IconSeeker
						icon="trophy"
						iconWeight="light"
						sx={{ color: 'warning.main', position: 'absolute', left: 0, top: 4 }}
					/> }
					{formatPriceSymbol(value, currency, { displayZero: true })}
				</Box>  }
				{ !value && <Box sx={{ color: 'text.disabled' }}>
					N/A
				</Box>  }
			</Box>
		}
	}
}